module.exports = __webpack_public_path__ + "img/meta.63cde07e.jpg";